/** Step 4 "Candidate list" and the "Talent preview" drawer. */
const wizCandidatesListEN = {
  wizListOverview: 'Candidate overview',
  wizListFilterAll: 'All candidates',
  wizListFilterOther: 'Candidates of other campaigns',
  wizListFilterSex: 'Unclear gender',
  wizListFilterBlocked: 'Blocked candidates',
  wizListHeadline: '{{active}} of {{total}} candidates on the final candidate list',
  wizListProgress:
    'First preview from the search · SAIA keeps rating about {{amount}} more profiles after the start',
  wizListJudgeLabel: 'AI verdict:',
  wizListJudgeA: 'Must criteria met',
  wizListJudgeB: 'Must criteria not shown',
  wizListJudgeC: 'Exclusion',
  wizListRatingFailed: 'Failed',
  wizListRatingFailedHint: 'The rating failed.',
  wizListRatingAnalysing: 'Being analysed',
  wizListRatingAnalysingHint: 'The profile is analysed first, then it is rated.',
  wizListRatingLinkedin: 'Waiting (LinkedIn limit)',
  wizListRatingLinkedinHint:
    'Profile analysis is paused because LinkedIn has temporarily limited profile views for this account. SAIA continues the analysis automatically.',
  wizListAnalysisPause:
    'Profile analysis paused.',
  wizListPauseLead:
    'Profile analysis paused: LinkedIn has temporarily limited profile views for this account.',
  wizListPauseResumes: 'SAIA will continue analysing the remaining candidates automatically (expected from {{date}}).',
  wizListPauseResumesAuto: 'SAIA will continue analysing the remaining candidates automatically.',
  wizListPauseReducedHalf: 'To protect the account, SAIA views only half as many profiles per day until {{date}}.',
  wizListPauseReduced: 'To protect the account, SAIA views fewer profiles per day until {{date}}.',
  wizListRatingQuota: 'Waiting (quota)',
  wizListRatingQuotaHint:
    'Waiting for analysis: the daily quota for profile analyses is used up. The analysis continues as soon as quota is free again – automatically or via "Rate again".',
  wizDrawerRejudgeError: 'The rating could not be restarted.',
  wizDrawerRejudge: 'Rate again',
  wizListJudgePending: 'Being rated',
  wizListColActive: 'Active',
  wizListColName: 'Name',
  wizListColJudge: 'AI verdict',
  wizListColCompany: 'Company',
  wizListColTitle: 'Job title',
  wizListSources: 'Source',
  wizListSourceName: 'Link {{n}} · {{kind}}',
  wizListSourceSkipped: 'skipped – finds nobody',
  wizListSourceFailed: 'search failed',
  wizListSourceFix: 'Fix',
  wizListSourceLoaded: '{{loaded}} of {{total}}',
  wizListSourceLoadedOnly: '{{loaded}} loaded',
  wizListColSource: 'Link',
  wizListSourceShort: 'L{{n}}',
  wizListColLocation: 'Location',
  wizListOtherCampaign: 'In another campaign',
  wizListUnclearSex: 'Unclear gender',
  wizListMoreAfterStart: 'Once the campaign is running, SAIA loads more contacts automatically.',
  wizListMoreAvailable: 'About {{count}} more profiles are waiting at LinkedIn.',
  wizListLoadMore: 'Load next 50',
  wizListLoadMoreBusy: 'Loading …',
  wizListUnclearSexSet: 'Click to set the gender',
  wizListSexTitle: 'Set gender',
  wizListSexBody: 'The gender could not be detected reliably. Check the LinkedIn profile and set it – the candidate is then addressed according to the rating again.',
  wizListSexFemale: 'Female',
  wizListSexMale: 'Male',
  wizListSexCancel: 'Cancel',
  wizListSexSave: 'Save',
  wizListBlacklist: 'Blacklist',
  wizListEmpty: 'No candidates in this view.',
  wizListLoading: 'Loading candidates …',
  wizListAnalysing: 'The profile of {{amount}} candidates is analysed first, then they are rated.',
  wizListAnalysisQuota:
    'The daily quota for profile analyses is used up. The analysis continues as soon as quota is free again.',
  wizListImporting: 'SAIA is loading and rating the first candidates from the search …',
  wizListLoadError: 'The candidates could not be loaded.',
  wizListActionError: 'The change could not be saved.',
  wizListOpen: 'View candidate',
  wizListToggleActive: 'Toggle active',
  wizDrawerProfileLink: 'Open LinkedIn profile',
  wizListMinutes: '{{minutes}} min',
  wizListHours: '{{hours}} h',
  wizListHoursMinutes: '{{hours}} h {{minutes}} min',
  wizListForecastAll: 'Analysis running: about {{minutes}} left for {{count}} candidates.',
  wizListForecastSplit:
    'Analysis running: {{today}} candidates today (about {{minutes}} left), the remaining {{rest}} from {{date}}.',
  wizListForecastSplitNoDate:
    'Analysis running: {{today}} candidates today (about {{minutes}} left), the remaining {{rest}} on the following working days.',
  wizListForecastRest:
    'No further analyses are possible today. SAIA analyses the remaining {{rest}} candidates from {{date}}.',
  wizListForecastRestNoDate:
    'No further analyses are possible today. SAIA analyses the remaining {{rest}} candidates on the following working days.',
  wizListRecommend:
    'The search is running. You do not have to wait: keep setting up the campaign in the meantime. SAIA will email you as soon as the profiles of this search run have been analysed, so you can review and approve them.',
  wizListForecastContinue: 'Continue',
  wizListLimitTitle: 'Today\u0027s analysis is complete',
  wizListLimitBody:
    'Since, according to your settings, we make at most {{limit}} profile visits per day, we will let you know when the analysis for this run is complete – and every time new analyses are available, so you can review the candidates.',
  wizListLimitOk: 'Got it',
  wizDrawerTitle: 'Talent preview',
  wizDrawerClose: 'Close',
  wizDrawerPrev: 'Previous candidate',
  wizDrawerNext: 'Next candidate',
  wizDrawerYears: '{{location}} · {{years}} years of experience',
  wizDrawerAt: '{{title}} at {{company}}',
  wizDrawerChangeJudgement: 'Change rating',
  wizDrawerManual: 'manually adjusted · ',
  wizDrawerOrigJudge: 'AI verdict: {{label}}',
  wizDrawerBlockedPerson: 'Candidate is on: {{lists}}',
  wizDrawerBlockedCompany: '{{company}} is on: {{lists}}',
  wizDrawerExclude: 'Exclude from contact list',
  wizDrawerInclude: 'Add to contact list',
  wizDrawerPersonAdd: 'Add candidate to blacklist …',
  wizDrawerPersonRemove: 'Remove candidate from blacklist',
  wizDrawerCompanyAdd: 'Add {{company}} to blacklist …',
  wizDrawerCompanyRemove: 'Remove {{company}} from blacklist',
  wizDrawerAddTo: 'Add {{name}} to …',
  wizDrawerTargetCampaign: 'Only this campaign',
  wizDrawerTargetCampaignMeta: 'Campaign blacklist',
  wizDrawerTargetGlobalCompanies: 'Global · {{amount}} companies',
  wizDrawerTargetGlobalContacts: 'Global · {{amount}} contacts',
  wizDrawerTargetOff: ' · off for this campaign',
  wizDrawerTabOverview: 'Candidate rating overview',
  wizDrawerTabCandidate: 'About candidate',
  wizDrawerTabCompany: 'About company',
  wizDrawerAssessment: 'AI assessment',
  wizDrawerPsychology: 'Psychological profile',
  wizDrawerPsychologyHint: 'AI analysis of the profile',
  wizDrawerPersonality: 'Personality type',
  wizDrawerPersonaTabType: 'Personality type',
  wizDrawerPersonaTabDos: 'Do\u0027s',
  wizDrawerPersonaTabDonts: 'Don\u0027ts',
  wizDrawerPersonaTabBoosters: 'Booster words',
  wizDrawerMotives: 'Motives',
  wizDrawerMotiveTop: 'Relationship',
  wizDrawerMotiveRight: 'Influence',
  wizDrawerMotiveBottom: 'Risk',
  wizDrawerMotiveLeft: 'Performance',
  wizDrawerStyle: 'Language style',
  wizDrawerStyleFormal: 'formal',
  wizDrawerStyleInformal: 'informal',
  wizDrawerAccTraits: 'Traits of {{name}}',
  wizDrawerAccDefines: 'What defines {{name}}',
  wizDrawerAccImportant: 'What matters to {{name}}',
  wizDrawerAccQuestions: 'Answer these questions for {{name}}',
  wizDrawerPersonaHint: 'Automatically shapes tone and wording of the messages to {{name}}.',
  wizDrawerNoPersona: 'There is no personality analysis for this candidate yet.',
  wizDrawerSkillMatch: 'Skills compared with your criteria',
  wizDrawerGroupMust: 'Must',
  wizDrawerGroupNice: 'Nice to have',
  wizDrawerGroupExcl: 'Exclusion',
  wizDrawerAnalysed: 'Analysed by SAIA based on the LinkedIn profile',
  wizDrawerExperience: 'Work experience',
  wizDrawerSkills: 'Skills',
  wizDrawerCompanyName: 'Company',
  wizDrawerIndustry: 'Industry',
  wizDrawerSize: 'Size',
  wizDrawerSizeValue: '{{size}} employees',
  wizDrawerLocation: 'Location',
  wizDrawerLoading: 'Loading details …',
  wizDrawerLoadError: 'The details could not be loaded.',
  wizListSearchFailed:
    'LinkedIn returned no results for this search. Check job titles and locations in step 2.',
  wizListSearchFailedReason: 'The search failed: {{reason}}',
  wizListRestartSearch: 'Restart search',
  wizListStartSearch: 'Start search',
  wizListRestartBusy: 'Starting the search …',
  wizListRestartError: 'The search could not be started.',
  wizListNoCandidates: 'No candidates found',
  wizListNotStarted: 'The search has not been started yet.',
  wizListSearchPlaceholder: 'Search name, job title, company or location',
  wizListFilterClassLabel: 'Class:',
  wizListFilterStatusLabel: 'Status:',
  wizListFilterLocationAll: 'All locations',
  wizListFilterCompanyAll: 'All companies',
  wizListFilterCount: '{{shown}} of {{total}} candidates',
  wizListFilterReset: 'Reset filters',
  wizListStatusRated: 'Rated',
  wizListStatusAnalysing: 'Being analysed / rated',
  wizListStatusQuota: 'Waiting for quota',
  wizListStatusFailed: 'Failed',
  wizListStatusExcluded: 'Blacklist / not a fit',
  wizListSelectAll: 'Select all',
  wizListSelectRow: 'Select candidate',
  wizListSelected: '{{count}} selected',
  wizListBulkRejudge: 'Rate again',
  wizListBulkBlacklistPeople: 'People to campaign blacklist',
  wizListBulkBlacklistCompanies: 'Companies to campaign blacklist',
  wizListBulkExport: 'Export (CSV)',
  wizListBulkConfirmBlacklist:
    'Add {{count}} candidates to the campaign blacklist? They will not be contacted.',
  wizListBulkDone: '{{done}} of {{total}} done.',
  wizDrawerCriteria: 'Criteria of this campaign',
  wizDrawerCriteriaNote: 'The AI assigns a class with an explanation, not a verdict per criterion.',
};
export default wizCandidatesListEN;
